import React, { useContext, useEffect, useMemo } from "react";
import "../css/paysuccess.css";
import Header from "./Header";
import Footer from "./Footer";
import { FiAlertCircle, FiArrowRight, FiCheck } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "./CartContext";
import siteConfig, { formatPrice } from "../config/siteConfig";

const PaySuccess = () => {
  const location = useLocation();
  const { clearCart } = useContext(CartContext);
  const state = new URLSearchParams(location.search).get("state") || "success";
  const pending = useMemo(() => {
    try { return JSON.parse(window.sessionStorage.getItem(siteConfig.storage.pendingOrder)) || {}; }
    catch { return {}; }
  }, []);

  useEffect(() => {
    if (state === "success") {
      clearCart();
      window.sessionStorage.removeItem(siteConfig.storage.pendingOrder);
    }
  }, [state, clearCart]);

  const success = state === "success";
  return <div className="success-page"><Header /><main className={`success-page__main ${success ? "" : "is-cancelled"}`}>
    <div className="success-page__mark">{success ? <FiCheck /> : <FiAlertCircle />}</div>
    <span className="eyebrow">{success ? "Payment successful" : "Payment cancelled"}</span>
    <h1>{success ? <>Thank you.<br />Your order is confirmed.</> : <>No charge made.<br />Your bag is still waiting.</>}</h1>
    <p>{success ? <>A confirmation for order <strong>{pending.orderNo || "your order"}</strong> is on its way to {pending.email || "your email"}. We’ll send tracking details after dispatch.</> : "The payment was cancelled or could not be completed. You can return to checkout and try again when ready."}</p>
    {success && pending.total > 0 && <div className="success-page__total"><span>Order total</span><strong>{formatPrice(pending.total)}</strong></div>}
    <div className="success-page__actions"><Link className="app-button" to={success ? "/shop" : "/checkout"}>{success ? "Continue shopping" : "Return to checkout"} <FiArrowRight /></Link><Link to="/contact">Contact customer care</Link></div>
  </main><Footer /></div>;
};

export default PaySuccess;
